export default __webpack_public_path__ + "static/media/shape-7.ebd965d6.svg";